import { EventEntityNameInCaseForm, IApiChangeHistoryEvent, IApiDbActionCode } from '@tap/data-providers';

const defaultChangeHistoryActions: { [key in IApiDbActionCode]: string } = {
    [IApiDbActionCode.Insert]: 'Создание',
    [IApiDbActionCode.Update]: 'Изменение',
    [IApiDbActionCode.Delete]: 'Удаление',
    [IApiDbActionCode.Transaction]: 'Измнение',
}

const getEventTitle = (event: IApiChangeHistoryEvent) => {
    if (event.dbActionCode === IApiDbActionCode.Transaction) {
        return 'Комплексное изменение';
    }

    const actionName = defaultChangeHistoryActions[event.dbActionCode];
    const entityName = event.entity in EventEntityNameInCaseForm ? EventEntityNameInCaseForm[event.entity] : event.entity;

    return `${actionName} ${entityName}`;
}

export type EventNameSlotProps = {
    eventItem: IApiChangeHistoryEvent,

}

export const EventName_BaseSlot = ({ eventItem }: EventNameSlotProps) => {
    return <>{getEventTitle(eventItem)}</>;
}